var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.10633 11.7056C5.7158 12.0961 5.08264 12.0961 4.69211 11.7056L0.406325 7.4198C0.015801 7.02928 0.0211945 6.39072 0.411719 6.0002C0.802243 5.60967 1.4408 5.60428 1.83133 5.9948L5.39922 9.5627L13.8671 1.0948C14.2576 0.704278 14.8962 0.709671 15.2867 1.1002C15.6772 1.49072 15.6826 2.12928 15.2921 2.5198L6.10633 11.7056Z",
    fill: "#58B039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.59c97c56c24161dfd640ebb75a5805da.svg";
export { ForwardRef as ReactComponent };